import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useTrendingHashtags } from '@/hooks/useHashtagSearch';
import { Hash, TrendingUp, Loader2 } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

const TrendingHashtags: React.FC = () => {
  const { hashtags, isLoading, fetchTrending } = useTrendingHashtags();

  useEffect(() => {
    fetchTrending();
  }, [fetchTrending]);

  if (isLoading) {
    return (
      <Card>
        <CardHeader className="pb-3">
          <CardTitle className="text-sm font-medium flex items-center gap-2">
            <TrendingUp className="h-4 w-4" />
            Trending Tags
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="flex justify-center py-4">
            <Loader2 className="h-5 w-5 animate-spin text-muted-foreground" />
          </div>
        </CardContent>
      </Card>
    );
  }

  if (hashtags.length === 0) {
    return null;
  }

  return (
    <Card>
      <CardHeader className="pb-3">
        <CardTitle className="text-sm font-medium flex items-center gap-2">
          <TrendingUp className="h-4 w-4" />
          Trending Tags
        </CardTitle>
      </CardHeader>
      <CardContent className="pt-0">
        <div className="space-y-2">
          {hashtags.map((hashtag, index) => (
            <Link
              key={hashtag.id}
              to={`/athlete-dashboard/wall/tag/${hashtag.tag}`}
              className="flex items-center justify-between py-2 px-3 -mx-3 rounded-lg hover:bg-accent transition-colors group"
            >
              <div className="flex items-center gap-2">
                <span className="text-xs font-medium text-muted-foreground w-4">
                  {index + 1}
                </span>
                <Hash className="h-4 w-4 text-primary" />
                <span className="font-medium group-hover:text-primary transition-colors">
                  {hashtag.tag}
                </span>
              </div>
              <span className="text-xs text-muted-foreground">
                {hashtag.post_count} posts
              </span>
            </Link>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};

export default TrendingHashtags;
